import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         Hi My Name is Rikhil Mani Tiwari.
        </p>
       <p>Welcome to my Website!</p>
      </header>
    </div>
  );
}

export default App;
